import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Icon5 from "../../assest/images/Icon5.png";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import config from "../../envconfig";
import CustomDropdown from "../common/CustomDropdown";
import StatusCustomDropdown from "../common/StatusCustomDropdown";
import { UserContext } from "../common/UserContext";
import Select from "react-select";
import { IoCaretUpOutline, IoCaretDownOutline } from 'react-icons/io5';
import { set } from "date-fns";

function SCPMEdit() {
  // const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useParams(); // Updated to include selectedScpId
  const {
    UM_GroupId,
    UM_CompanyGrpID,
    selectedScpId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    UM_DefaultSCPId,
  } = useContext(UserContext);
  const toastRef = useRef(null);
  const showToast = (type, message, options = {}) => {
    if (toastRef.current && toast.isActive(toastRef.current)) {
      toast.update(toastRef.current, {
        render: message,
        type,
        autoClose: 3000,
        ...options,
      });
    } else {
      toastRef.current = toast[type](message, {
        autoClose: 3000,
        ...options,
      });
    }
  };
  useEffect(() => {
    sessionStorage.setItem("UM_GroupId", UM_GroupId);
    sessionStorage.setItem("UM_CompanyGrpID", UM_CompanyGrpID);
    sessionStorage.setItem("UM_DefaultSCPId", UM_DefaultSCPId);
    sessionStorage.setItem("UM_CompanyID", UM_CompanyID);
    sessionStorage.setItem("UM_UserId", UM_UserId);
    sessionStorage.setItem("UM_UserCode", UM_UserCode);

    sessionStorage.setItem("selectedScpId", selectedScpId);
  }, [
    UM_GroupId,
    UM_CompanyGrpID,
    UM_DefaultSCPId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    selectedScpId,
  ]);
  const [formdata, setFormdata] = useState({
    SCPM_Name: "",
    SCPM_Caption: "",
    SCPM_SCPConfig_ID: "",
    SCPM_Status: 1,
    SCPM_ScanningMode: "",
    SCPMO_OutwardParty: "",
    SCPMSL_SameLevelParty: "",
    SCPM_CompanyGrpID: UM_CompanyGrpID,
    SCPM_CompanyID: UM_CompanyID,
  });
  const [oldData, setOlddata] = useState({
    SCPM_Name: "",
    SCPM_Caption: "",
    SCPM_SCPConfig_ID: "",
    SCPM_Status: "",
    SCPM_ScanningMode: "",
    SCPMO_OutwardParty: "",
    SCPMSL_SameLevelParty: "",
    SCPM_CompanyGrpID: UM_CompanyGrpID,
    SCPM_CompanyID: UM_CompanyID,
  });

  const { SCPM_ID } = useParams();
  const [message, setMessage] = useState("");
  const [scpLevelNames, setscpLevelNames] = useState([]);
  const [scps, setScps] = useState([]);
  const [op_scps, setOP_Scps] = useState([]);
  const navigate = useNavigate();
  const [selectedScps, setSelectedScps] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [submittedSLP, setSubmittedSLP] = useState(false);
  const [selectedSameLevelParties, setSelectedSameLevelParties] = useState([]);

  const [isAddClicked, setIsAddClicked] = useState(false); // New state variable
  const [isAddClickedSLP, setIsAddClickedSLP] = useState(false); // New state variable


  // Add these state variables to track disabled SCP IDs
  const [disabledOutwardScps, setDisabledOutwardScps] = useState([]);
  const [disabledSameLevelScps, setDisabledSameLevelScps] = useState([]);

  // Add these state variables to track working selections (before ADD is clicked)
  const [workingSelectedScps, setWorkingSelectedScps] = useState([]);
  const [workingSelectedSameLevelParties, setWorkingSelectedSameLevelParties] = useState([]);

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [onConfirmAction, setOnConfirmAction] = useState(null);

  const [scanningModeOptions, setScanningModeOptions] = useState([]);
  const [scanningModeLoading, setScanningModeLoading] = useState(false);
  const initialData = {
    SCPM_Name: "",
    SCPM_Caption: "",
    SCPM_SCPConfig_ID: "",
    SCPM_Status: "",
    SCPMO_OutwardParty: "",
    SCPMSL_SameLevelParty: "",
    SCPM_ScanningMode: "",
  };
  const [errors, setErrors] = useState({
    required: initialData,
    other: initialData,
  });

  const [isSelectOpen, setIsSelectOpen] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
  };

  // Audit Trail

  const audittransection = async (data) => {
    const formData = {
      AUTRN_ID: data.AUTRN_ID,
      AUTRN_OldValue: data.AUTRN_OldValue ?? null,
      AUTRN_NewValue: data.AUTRN_NewValue,
      AUTRN_ParamererName: data.AUTRN_ParamererName,
    };
    try {
      const response = await axios.post(
        `${config.API_URL}/api/audittransaction`,
        formData
      );
      // alert('Data inserted successfully.');
    } catch (error) {
      if (error.response) {
        // Server responded with a status other than 2xx
        console.error("Server responded with an error:", error.response.data);
        // alert(`Error: ${error.response.status} - ${error.response.data}`);
      } else if (error.request) {
        // No response received from server
        console.error("No response received:", error.request);
        // alert('Error: No response received from server');
      } else {
        // Other errors
        console.error("Error setting up the request:", error.message);
        // alert('Error: Request setup failed');
      }
    }
  };

  const audittrailpost = async (details) => {
    const getCurrentTimestamp = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // months are zero-indexed
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const currentTimestamp = getCurrentTimestamp();
    const AUTR_OldValue = details?.AUTR_OldValue ?? null;
    const AUTR_NewValue = details?.AUTR_NewValue ?? null;
    const AUTR_Message = details.AUTR_Message;
    const AUTR_AuditType = details.AUTR_AuditType;
    if (
      UM_CompanyID === null ||
      UM_CompanyID === "null" ||
      UM_CompanyGrpID === null ||
      UM_CompanyGrpID === "null" ||
      selectedScpId === null ||
      selectedScpId === "null"
    ) {
      console.log("null--------");
      const data = {
        AUTR_ScreenName: "User Master",
        AUTR_OldValue: AUTR_OldValue,
        AUTR_NewValue: AUTR_NewValue,
        AUTR_Message: AUTR_Message,
        AUTR_UserID: UM_UserId,
        AUTR_UserName: UM_UserCode,
        AUTR_TimeStamp: currentTimestamp,
        AUTR_AuditType: AUTR_AuditType,
        AUTR_SCPID: null,
        AUTR_CompanyGrpId: null,
        AUTR_CompanyID: null,
        AUTR_CreatedBy: UM_UserId,
        AUTR_CreatedDateTime: currentTimestamp,
      };
      console.log(data);
      try {
        const response = await axios.post(
          `${config.API_URL}/api/audittrail`,
          data
        );
        console.log("Success:", response.data);
        return response.data;
      } catch (error) {
        console.error("Error:", error);
      }
    } else {
      console.log("null--------");
      const data = {
        AUTR_ScreenName: "SCP Master",
        AUTR_OldValue: AUTR_OldValue,
        AUTR_NewValue: AUTR_NewValue,
        AUTR_Message: AUTR_Message,
        AUTR_UserID: UM_UserId,
        AUTR_UserName: UM_UserCode,
        AUTR_TimeStamp: currentTimestamp,
        AUTR_AuditType: AUTR_AuditType,
        AUTR_SCPID: selectedScpId,
        AUTR_CompanyGrpId: UM_CompanyID,
        AUTR_CompanyID: UM_CompanyID,
        AUTR_CreatedBy: UM_UserId,
        AUTR_CreatedDateTime: currentTimestamp,
      };
      console.log(data);
      try {
        const response = await axios.post(
          `${config.API_URL}/api/audittrail`,
          data
        );
        console.log("Success:", response.data);
        return response.data;
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  // State to store SCP AllowMutlipleParty values
  const [scpAllowMutlipleParty, setScpAllowMutlipleParty] = useState({
    SCP_AllowMutliplePartySameLevelOutward: "",
    SCP_AllowMutliplePartyOutward: "",
  });
  // Fetch SCP AllowMutlipleParty values based on selected SCP Level Number
  useEffect(() => {
    const fetchSCPAllowMutlipleParty = async () => {
      try {
        const response = await axios.get(
          `${config.API_URL}/SL_ML_OP/${UM_CompanyGrpID}/${formdata.SCPM_SCPConfig_ID}`
        );
        const data = response.data;
        if (response.status === 200) {
          setScpAllowMutlipleParty(data);
          logAction(
            "fetchSCPAllowMutlipleParty():data get from API according to yes and no. "
          );
        } else {
          showToast('error',
            "Error fetching SCP AllowMutlipleParty data according to yes and no.."
          );
          logAction(
            "fetchSCPAllowMutlipleParty():Error fetching SCP AllowMutlipleParty data. Server returned",
            true
          );
          console.error(
            "Error fetching SCP AllowMutlipleParty data. Server returned:",
            response.status
          );
        }
      } catch (error) {
        showToast('error',
          "Error fetching SCP AllowMutlipleParty data according to yes and no.."
        );
        logAction(
          "fetchSCPAllowMutlipleParty(): Failed to fetch SCP AllowMutlipleParty data ",
          true
        );
        console.error("Failed to fetch SCP AllowMutlipleParty data:", error);
      }
    };
    if (formdata.SCPM_SCPConfig_ID !== "") {
      fetchSCPAllowMutlipleParty();
    }
  }, [UM_CompanyGrpID, formdata.SCPM_SCPConfig_ID]);

  // Fetch scanning mode data based on company configuration
  // useEffect(() => {
  //   const fetchScanningMode = async () => {
  //     // Only fetch if company ID is available
  //     if (!UM_CompanyID || UM_CompanyID === "null") {
  //       return;
  //     }

  //     setScanningModeLoading(true);
  //     try {
  //       const response = await axios.get(
  //         `${config.API_URL}/scanning-mode/${UM_CompanyID}`
  //       );

  //       if (response.status === 200) {
  //         let options = [];

  //         // Handle both array and single object responses from API
  //         if (Array.isArray(response.data)) {
  //           // Multiple options (scanningMode = 3)
  //           options = response.data.map(item => ({
  //             value: item.EnumVal.toString(),
  //             label: item.Description
  //           }));
  //         } else if (response.data && response.data.EnumVal) {
  //           // Single option
  //           options = [{
  //             value: response.data.EnumVal.toString(),
  //             label: response.data.Description
  //           }];
  //         }

  //         setScanningModeOptions(options);

  //         // If there's only one option, auto-select it
  //         if (options.length === 1 && !formdata.SCPM_ScanningMode) {
  //           setFormdata(prev => ({
  //             ...prev,
  //             SCPM_ScanningMode: options[0].value
  //           }));
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch scanning mode:", error);
  //       showToast('error',"Failed to load scanning mode options");
  //       // Fallback to default options
  //       setScanningModeOptions([
  //         { value: "1", label: "Vendor" },
  //         { value: "2", label: "Product" }
  //       ]);
  //     } finally {
  //       setScanningModeLoading(false);
  //     }
  //   };

  //   fetchScanningMode();
  // }, [UM_CompanyID]); // Re-fetch when company ID changes

  // Default scanning mode options
  const defaultScanningModeOptions = [
    { value: "1", label: "Vendor" },
    { value: "2", label: "Product" },
  ];
  // Fetch scanning mode data based on company configuration
  // useEffect(() => {
  //   const fetchScanningMode = async () => {
  //     // Only fetch if company ID is available
  //     if (!UM_CompanyID || UM_CompanyID === "null") {
  //       return;
  //     }

  //     setScanningModeLoading(true);
  //     try {
  //       const response = await axios.get(
  //         `${config.API_URL}/scanning-mode/${UM_CompanyID}`
  //       );

  //       if (response.status === 200) {
  //         let options = [];

  //         // Handle both array and single object responses from API
  //         if (Array.isArray(response.data)) {
  //           // Multiple options (scanningMode = 3)
  //           options = response.data.map(item => ({
  //             value: item.EnumVal.toString(),
  //             label: item.Description
  //           }));

  //           // Sort options to ensure Vendor (1) comes before Product (2)
  //           options.sort((a, b) => parseInt(a.value) - parseInt(b.value));

  //           // If both options are available, select Vendor (first one) by default
  //           if (options.length === 2 && !formdata.SCPM_ScanningMode) {
  //             setFormdata(prev => ({
  //               ...prev,
  //               SCPM_ScanningMode: options[0].value // Vendor (value: "1")
  //             }));
  //           } else if (options.length === 1 && !formdata.SCPM_ScanningMode) {
  //             // If only one option is available, select it by default
  //             setFormdata(prev => ({
  //               ...prev,
  //               SCPM_ScanningMode: options[0].value
  //             }));
  //           }
  //         } else if (response.data && response.data.EnumVal) {
  //           // Single option
  //           options = [{
  //             value: response.data.EnumVal.toString(),
  //             label: response.data.Description
  //           }];

  //           // If only one option is available, select it by default
  //           if (!formdata.SCPM_ScanningMode) {
  //             setFormdata(prev => ({
  //               ...prev,
  //               SCPM_ScanningMode: options[0].value
  //             }));
  //           }
  //         }

  //         setScanningModeOptions(options);
  //       } else {
  //         // If API fails, use fallback options
  //         setScanningModeOptions(defaultScanningModeOptions);

  //         // Select Vendor by default for fallback options
  //         if (!formdata.SCPM_ScanningMode) {
  //           setFormdata(prev => ({
  //             ...prev,
  //             SCPM_ScanningMode: "1" // Vendor
  //           }));
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch scanning mode:", error);
  //       showToast('error',"Failed to load scanning mode options");

  //       // Fallback to default options
  //       setScanningModeOptions(defaultScanningModeOptions);

  //       // Select Vendor by default for fallback options
  //       if (!formdata.SCPM_ScanningMode) {
  //         setFormdata(prev => ({
  //           ...prev,
  //           SCPM_ScanningMode: "1" // Vendor
  //         }));
  //       }
  //     } finally {
  //       setScanningModeLoading(false);
  //     }
  //   };

  //   fetchScanningMode();
  // }, [UM_CompanyID]); // Re-fetch when company ID changes
  // Fetch scanning mode data based on company configuration
  useEffect(() => {
    const fetchScanningMode = async () => {
      // Only fetch if company ID is available
      if (!UM_CompanyID || UM_CompanyID === "null") {
        return;
      }

      setScanningModeLoading(true);
      try {
        const response = await axios.get(
          `${config.API_URL}/scanning-mode/${UM_CompanyID}`
        );

        if (response.status === 200) {
          let options = [];

          // Handle both array and single object responses from API
          if (Array.isArray(response.data)) {
            // Multiple options (scanningMode = 3)
            options = response.data.map(item => ({
              value: item.EnumVal.toString(),
              label: item.Description
            }));

            // Sort options to ensure Vendor (1) comes before Product (2)
            options.sort((a, b) => parseInt(a.value) - parseInt(b.value));

            // If there's only one option, auto-select it
            if (options.length === 1 && !formdata.SCPM_ScanningMode) {
              // Single option: auto-select it
              setFormdata(prev => ({
                ...prev,
                SCPM_ScanningMode: options[0].value
              }));
            } else if (options.length === 2 && !formdata.SCPM_ScanningMode) {
              // Two options: keep it blank (don't auto-select)
              // Do nothing - leave it as empty string
            }
          } else if (response.data && response.data.EnumVal) {
            // Single option
            options = [{
              value: response.data.EnumVal.toString(),
              label: response.data.Description
            }];

            // If only one option is available, select it by default
            if (!formdata.SCPM_ScanningMode) {
              setFormdata(prev => ({
                ...prev,
                SCPM_ScanningMode: options[0].value
              }));
            }
          }

          setScanningModeOptions(options);
        } else {
          // If API fails, use fallback options
          setScanningModeOptions(defaultScanningModeOptions);
        }
      } catch (error) {
        console.error("Failed to fetch scanning mode:", error);
        showToast('error', "Failed to load scanning mode options");

        // Fallback to default options
        setScanningModeOptions(defaultScanningModeOptions);
      } finally {
        setScanningModeLoading(false);
      }
    };

    fetchScanningMode();
  }, [UM_CompanyID]); // Re-fetch when company ID changes
  useEffect(() => {
    const fetchscpLevelNames = async () => {
      try {
        const response = await axios.get(
          `${config.API_URL}/SCPCONFIG_Name/${UM_CompanyGrpID}`
        );
        const data = response.data;

        if (response.status === 200) {
          if (data.length > 0) {
            setscpLevelNames(data);
            logAction(
              "fetchscpLevelNames(): Get SCP level name data from API "
            );
          } else {
            console.error("Invalid API response:", data);
            showToast('error',
              "Failed to fetch SCP Level Names. Please check your network connection."
            );
            logAction(
              " fetchscpLevelNames(): Invalid API response. Please check the server logs.",
              true
            );
            // setMessage('Invalid API response. Please check the server logs.');
          }
        } else {
          console.error(
            "Error fetching SCP Level Names. Server returned:",
            response.status
          );
          showToast('error',
            "Failed to fetch SCP Level Names. Please check your network connection."
          );
          logAction(
            " fetchscpLevelNames():Error fetching SCP Level Names. Please try again. ",
            true
          );
          // setMessage('Error fetching SCP Level Names. Please try again.');
        }
      } catch (error) {
        console.error("Failed to fetch SCP Level Names:", error);
        logAction(
          "fetchscpLevelNames(): Failed to fetch SCP data. Please check your network connection. ",
          true
        );
        showToast('error',
          "Failed to fetch SCP Level Names. Please check your network connection."
        );
        // setMessage('Failed to fetch SCP Level Names. Please check your network connection.');
      }
    };
    // ... (fetchScps remains unchanged)
    fetchscpLevelNames();
  }, [UM_CompanyGrpID]);

  useEffect(() => {
    const fetchSCPData = async () => {
      try {
        const response = await axios.get(
          `${config.API_URL}/scp_master/edit/${SCPM_ID}`
        );
        const data = response.data;
        if (response.status === 200) {
          const {
            scpmaster,
            scpmastersameleveloutwardlist,
            scpmasteroutwardlist,
          } = data;
          console.log("data", data);
          setFormdata({
            SCPM_Name: scpmaster.SCPM_Name,
            SCPM_Caption: scpmaster.SCPM_Caption,
            SCPM_Code: scpmaster.SCPM_Code,
            SCPM_SCPConfig_ID: scpmaster.SCPM_SCPConfig_ID,
            SCPM_Status: scpmaster.SCPM_Status,
            SCPM_ScanningMode: scpmaster.SCPM_ScanningMode,
            SCPMO_OutwardParty: scpmasteroutwardlist.map(
              (item) => item.SCPM_ID
            ), // Adjust this according to your data structure
            SCPMSL_SameLevelParty: scpmastersameleveloutwardlist.map(
              (item) => item.SCPM_ID
            ), // Adjust this according to your data structure
          });
          setIsAddClicked(true);
          setIsAddClickedSLP(true);
          setSubmittedSLP(true);
          setSubmitted(true);

          setOlddata({
            SCPM_Name: scpmaster.SCPM_Name,
            SCPM_Caption: scpmaster.SCPM_Caption,
            SCPM_Code: scpmaster.SCPM_Code,
            SCPM_SCPConfig_ID: scpmaster.SCPM_SCPConfig_ID,
            SCPM_Status: scpmaster.SCPM_Status,
            SCPM_ScanningMode: scpmaster.SCPM_ScanningMode,
            SCPMO_OutwardParty: scpmasteroutwardlist.map(
              (item) => item.SCPM_ID
            ), // Adjust this according to your data structure
            SCPMSL_SameLevelParty: scpmastersameleveloutwardlist.map(
              (item) => item.SCPM_ID
            ),
          });
          logAction(
            "fetchSCPData():  All data Get by id in input fields from API "
          );

          const outwardPartyIds = scpmasteroutwardlist.map(
            (item) => item.SCPM_ID
          );
          setSelectedScps(outwardPartyIds); // Set initial value of selectedScps
          setWorkingSelectedScps(outwardPartyIds); // NEW: Initialize working selection
          setDisabledOutwardScps(outwardPartyIds); // NEW: Initialize disabled SCP IDs
          logAction(
            "fetchSCPData():  SCP outward party data Get by id in input fields from API "
          );

          const sameLevelPartyIds = scpmastersameleveloutwardlist.map(
            (item) => item.SCPM_ID
          );
          setSelectedSameLevelParties(sameLevelPartyIds); // Set initial value of selectedSameLevelParties
          setWorkingSelectedSameLevelParties(sameLevelPartyIds); // NEW: Initialize working selection
          setDisabledSameLevelScps(sameLevelPartyIds); // NEW: Initialize disabled SCP IDs
          logAction(
            "fetchSCPData():  SCP Same level data Get by id in input fields from API "
          );
        } else if (response.status === 404) {
          console.error("SCPM_ID not found");
          logAction("fetchSCPData(): SCPM_ID not found", true);
          showToast('error',
            "Failed to fetch SCP data. Please check your network connection."
          );
        } else {
          console.error("Failed to fetch SCP data:", response.status);
          showToast('error',
            "Failed to fetch SCP data. Please check your network connection."
          );
          logAction("fetchSCPData(): Failed to fetch SCP data", true);
        }
      } catch (error) {
        console.error("Failed to fetch SCP data:", error);
        showToast('error',
          "Failed to fetch SCP data. Please check your network connection."
        );
        logAction("fetchSCPData(): Failed to fetch SCP data ", true);
      }
    };
    fetchSCPData();
  }, [SCPM_ID]);

  useEffect(() => {
    const fetchScpsByLevelNo = async () => {
      try {
        // Fetch SCPM names based on the selected SCPM Level Number
        const response = await axios.get(
          `${config.API_URL}/SCPM_SLP/${UM_CompanyGrpID}/${formdata.SCPM_SCPConfig_ID}`
        );
        const data = response.data;

        if (response.status === 200) {
          if (data.SCPM_Names) {
            // Update to SCPM_Names
            setScps(data.SCPM_Names); // Update to SCPM_Names
            logAction(
              "fetchScpsByLevelNo(): Get SCP same level name data from API "
            );
          } else {
            console.error("Invalid SCP API response:", data);
            showToast('error',
              "Failed to fetch SCP Same Level data. Please check your network connection."
            );
            logAction(
              "fetchScpsByLevelNo(): Invalid API response. Please check the server logs.",
              true
            );
            // setMessage('Invalid SCP API response. Please check the server logs.');
          }
        } else {
          console.error(
            "Error fetching SCP data. Server returned:",
            response.status
          );
          showToast('error',
            "Failed to fetch SCP Same Level data. Please check your network connection."
          );
          logAction(
            "fetchScpsByLevelNo(): Error fetching SCP data. Please try again.",
            true
          );

          // setMessage('Error fetching SCP data. Please try again.');
        }
      } catch (error) {
        console.error("Failed to fetch SCP data:", error);
        showToast('error',
          "Failed to fetch SCP Same Level data. Please check your network connection."
        );
        logAction(
          "fetchScpsByLevelNo(): Failed to fetch SCP data. Please check your network connection.",
          true
        );
        // setMessage('Failed to fetch SCP Same Level data. Please check your network connection.');
      }
    };
    // Fetch SCPM names based on the selected SCPM Level Number
    if (formdata.SCPM_SCPConfig_ID !== "") {
      fetchScpsByLevelNo();
    }
  }, [UM_CompanyGrpID, formdata.SCPM_SCPConfig_ID]);

  useEffect(() => {
    const fetchOPScpsByLevelNo = async () => {
      try {
        // Fetch SCPM names based on the selected SCPM Level Number
        const response = await axios.get(
          `${config.API_URL}/SCPM_SLP_OP/${UM_CompanyGrpID}/${formdata.SCPM_SCPConfig_ID}`
        );
        const data = response.data;
        if (response.status === 200) {
          if (data.SCPM_Names) {
            setOP_Scps(data.SCPM_Names);
            logAction(
              "fetchOPScpsByLevelNo(): Get SCP Outward party data from API "
            );
          } else {
            console.error("Invalid SCP API response:", data);
            showToast('error',
              "Failed to fetch SCP Outward Party data. Please check your network connection."
            );
            logAction(
              "fetchOPScpsByLevelNo(): Invalid SCP API response. Please check the server logs.",
              true
            );
            // setMessage('Invalid SCP API response. Please check the server logs.');
          }
        } else {
          console.error(
            "Error fetching SCP data. Server returned:",
            response.status
          );
          showToast('error',
            "Failed to fetch SCP Outward Party data. Please check your network connection."
          );
          logAction(
            "fetchOPScpsByLevelNo(): Error fetching SCP data. Please try again.",
            true
          );
          // setMessage('Error fetching SCP data. Please try again.');
        }
      } catch (error) {
        console.error("Failed to fetch SCP data:", error);
        showToast('error',
          "Failed to fetch SCP Outward Party data. Please check your network connection."
        );
        logAction(
          "fetchOPScpsByLevelNo(): Failed to fetch SCP data. Please check your network connection.",
          true
        );
        // setMessage('Failed to fetch SCP data. Please check your network connection.');
      }
    };
    // Fetch SCPM names based on the selected SCPM Level Number
    if (formdata.SCPM_SCPConfig_ID !== "") {
      fetchOPScpsByLevelNo();
    }
  }, [UM_CompanyGrpID, formdata.SCPM_SCPConfig_ID]);

  const handleOPSubmit = (e) => {
    e.preventDefault();
    // Validate required fields
    if (
      scpAllowMutlipleParty.SCP_AllowMutliplePartyOutward !== 0 &&
      workingSelectedScps.length === 0
    ) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        required: {
          ...prevErrors.required,
          SCPMO_OutwardParty: "*",
        },
      }));
      return;
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        required: {
          ...prevErrors.required,
          SCPMO_OutwardParty: "",
        },
      }));
    }
    setSubmitted(true);
    setIsAddClicked(true); // Update the state when "Add" button is clicked
    // Set the final selected scps to the working selection
    setSelectedScps(workingSelectedScps);

    // NEW: Disable the selected SCP IDs for outward party
    setDisabledOutwardScps([...disabledOutwardScps, ...workingSelectedScps]);

    setErrors((prevErrors) => ({ ...prevErrors, addButton: "" }));
    console.log("Selected SCPMO_OutwardParty data:", workingSelectedScps);
    logAction("handleOPSubmit(): Add SCP Outward party data ");
  };
  const handleSLPSubmit = (e) => {
    e.preventDefault();
    // Validate required fields
    if (
      scpAllowMutlipleParty.SCP_AllowMutliplePartySameLevelOutward !== 0 &&
      workingSelectedSameLevelParties.length === 0
    ) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        required: {
          ...prevErrors.required,
          SCPMSL_SameLevelParty: "*",
        },
      }));
      return;
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        required: {
          ...prevErrors.required,
          SCPMSL_SameLevelParty: "",
        },
      }));
    }
    setSubmittedSLP(true);
    setIsAddClickedSLP(true); // Update the state when "Add" button is clicked
    // Set the final selected same level parties to the working selection
    setSelectedSameLevelParties(workingSelectedSameLevelParties);

    // NEW: Disable the selected SCP IDs for same level party
    setDisabledSameLevelScps([...disabledSameLevelScps, ...workingSelectedSameLevelParties]);

    setErrors((prevErrors) => ({ ...prevErrors, addButton: "" }));
    console.log("Selected SCPMSL_SameLevelParty data:", workingSelectedSameLevelParties);
    logAction("handleSLPSubmit(): Add same level party data ");
  };
  const validateForm = () => {
    let valid = true;
    const newErrors = {
      required: { ...errors.required },
      other: { ...errors.other },
    };
    if (!formdata.SCPM_Name) {
      newErrors.required.SCPM_Name = "*";
      valid = false;
    } else {
      newErrors.required.SCPM_Name = "";
      newErrors.other.SCPM_Name = "";
    }
    if (!formdata.SCPM_Caption) {
      newErrors.required.SCPM_Caption = "*";
      valid = false;
    } else {
      newErrors.required.SCPM_Caption = "";
      newErrors.other.SCPM_Caption = "";
    }
    if (!formdata.SCPM_Status) {
      newErrors.required.SCPM_Status = "*";
      valid = false;
    } else {
      newErrors.required.SCPM_Status = "";
      newErrors.other.SCPM_Status = "";
    }
    if (!formdata.SCPM_SCPConfig_ID) {
      newErrors.required.SCPM_SCPConfig_ID = "*";
      valid = false;
    } else {
      newErrors.required.SCPM_SCPConfig_ID = "";
      newErrors.other.SCPM_SCPConfig_ID = "";
    }
    // Validate SCPM_ScanningMode
    if (!formdata.SCPM_ScanningMode) {
      newErrors.required.SCPM_ScanningMode = "*";
      valid = false;
    } else {
      newErrors.required.SCPM_ScanningMode = "";
      newErrors.other.SCPM_ScanningMode = "";
    }
    setErrors(newErrors);
    return valid;
  };
  const handleInput = (e) => {
    const { name, value, type, checked } = e.target;
    // Update form data
    setFormdata((prevFormData) => {
      if (type === "checkbox") {
        const updatedScps = checked
          ? [...selectedScps, parseInt(value)]
          : selectedScps.filter((scp) => scp !== parseInt(value));
        setSelectedScps(updatedScps);
        return { ...prevFormData, [name]: updatedScps };
      } else {
        return { ...prevFormData, [name]: value };
      }
    });

    let valid = true;
    const newErrors = {
      required: { ...errors.required },
      other: { ...errors.other },
    };

    if (name === "SCPM_Status") {
      if (!value) {
        newErrors.required.SCPM_Status = "*";
        valid = false;
      } else {
        newErrors.required.SCPM_Status = "";
        newErrors.other.SCPM_Status = "";
      }
    }

    if (name === "SCPM_ScanningMode") {
      if (!value) {
        // newErrors.required.SCPM_ScanningMode = "*";
        valid = false;
      } else {
        newErrors.required.SCPM_ScanningMode = "";
        newErrors.other.SCPM_ScanningMode = "";
      }
    }
    setErrors(newErrors);
    if (!valid) {
      return;
    }
  };

  // Update the handleCheckboxChange function:
  // const handleCheckboxChange = (e) => {
  //   const { name, value, checked } = e.target;
  //   const scpId = parseInt(value);

  //   if (!isNaN(scpId)) {
  //     // Use name to determine which state variable to update
  //     if (name === "SCPMO_OutwardParty") {
  //       const updatedScps = checked
  //         ? [...workingSelectedScps, scpId]
  //         : workingSelectedScps.filter((scp) => scp !== scpId);
  //       setWorkingSelectedScps(updatedScps);
  //     } else if (name === "SCPMSL_SameLevelParty") {
  //       const updatedSameLevelParties = checked
  //         ? [...workingSelectedSameLevelParties, scpId]
  //         : workingSelectedSameLevelParties.filter((scp) => scp !== scpId);
  //       setWorkingSelectedSameLevelParties(updatedSameLevelParties);
  //     }

  //     // Reset the ADD button state since changes were made
  //     if (name === "SCPMO_OutwardParty") {
  //       setIsAddClicked(false);
  //     } else if (name === "SCPMSL_SameLevelParty") {
  //       setIsAddClickedSLP(false);
  //     }
  //   }
  // };


  // const handleSelectAll = (name, checked) => {
  //   if (name === "SCPMO_OutwardParty") {
  //     // Get ENABLED (not disabled/not already added) ids
  //     const enabledIds = op_scps
  //       .filter((scp) => !disabledOutwardScps.includes(scp.SCPM_ID))
  //       .map((scp) => scp.SCPM_ID);

  //     if (checked) {
  //       // Add enabled items to existing selection
  //       const newSelection = Array.from(new Set([...workingSelectedScps, ...enabledIds]));
  //       setWorkingSelectedScps(newSelection);
  //     } else {
  //       // Remove only enabled items, keep disabled ones intact
  //       const newSelection = workingSelectedScps.filter((id) => !enabledIds.includes(id));
  //       setWorkingSelectedScps(newSelection);
  //     }

  //     setIsAddClicked(false);

  //   } else if (name === "SCPMSL_SameLevelParty") {
  //     // Enabled same-level SCPs (also excluding itself)
  //     const enabledIds = scps
  //       .filter(
  //         (scp) =>
  //           scp.SCPM_Name !== formdata.SCPM_Name &&
  //           !disabledSameLevelScps.includes(scp.SCPM_ID)
  //       )
  //       .map((scp) => scp.SCPM_ID);

  //     if (checked) {
  //       const newSelection = Array.from(
  //         new Set([...workingSelectedSameLevelParties, ...enabledIds])
  //       );
  //       setWorkingSelectedSameLevelParties(newSelection);
  //     } else {
  //       const newSelection = workingSelectedSameLevelParties.filter(
  //         (id) => !enabledIds.includes(id)
  //       );
  //       setWorkingSelectedSameLevelParties(newSelection);
  //     }

  //     setIsAddClickedSLP(false);
  //   }
  // };
  const handleCheckboxChange = (e) => {
  const { name, value, checked } = e.target;
  const scpId = parseInt(value);

  if (!isNaN(scpId)) {

    if (name === "SCPMO_OutwardParty") {

      const updatedScps = checked
        ? [...workingSelectedScps, scpId]
        : workingSelectedScps.filter((scp) => scp !== scpId);

      setWorkingSelectedScps(updatedScps);

      // ✅ CLEAR REQUIRED ERROR IF ANY SELECTED
      if (updatedScps.length > 0) {
        setErrors((prev) => ({
          ...prev,
          required: {
            ...prev.required,
            SCPMO_OutwardParty: "",
          },
        }));
      }

      setIsAddClicked(false);

    } else if (name === "SCPMSL_SameLevelParty") {

      const updatedSameLevelParties = checked
        ? [...workingSelectedSameLevelParties, scpId]
        : workingSelectedSameLevelParties.filter((scp) => scp !== scpId);

      setWorkingSelectedSameLevelParties(updatedSameLevelParties);

      // ✅ CLEAR REQUIRED ERROR
      if (updatedSameLevelParties.length > 0) {
        setErrors((prev) => ({
          ...prev,
          required: {
            ...prev.required,
            SCPMSL_SameLevelParty: "",
          },
        }));
      }

      setIsAddClickedSLP(false);
    }
  }
};
const handleSelectAll = (name, checked) => {

  if (name === "SCPMO_OutwardParty") {

    const enabledIds = op_scps
      .filter((scp) => !disabledOutwardScps.includes(scp.SCPM_ID))
      .map((scp) => scp.SCPM_ID);

    let newSelection;

    if (checked) {
      newSelection = Array.from(new Set([...workingSelectedScps, ...enabledIds]));
    } else {
      newSelection = workingSelectedScps.filter((id) => !enabledIds.includes(id));
    }

    setWorkingSelectedScps(newSelection);
    setIsAddClicked(false);

    // ✅ CLEAR ERROR IF ANY SELECTED
    if (newSelection.length > 0) {
      setErrors((prev) => ({
        ...prev,
        required: {
          ...prev.required,
          SCPMO_OutwardParty: "",
        },
      }));
    }

  } else if (name === "SCPMSL_SameLevelParty") {

    const enabledIds = scps
      .filter(
        (scp) =>
          scp.SCPM_Name !== formdata.SCPM_Name &&
          !disabledSameLevelScps.includes(scp.SCPM_ID)
      )
      .map((scp) => scp.SCPM_ID);

    let newSelection;

    if (checked) {
      newSelection = Array.from(
        new Set([...workingSelectedSameLevelParties, ...enabledIds])
      );
    } else {
      newSelection = workingSelectedSameLevelParties.filter(
        (id) => !enabledIds.includes(id)
      );
    }

    setWorkingSelectedSameLevelParties(newSelection);
    setIsAddClickedSLP(false);

    // ✅ CLEAR ERROR
    if (newSelection.length > 0) {
      setErrors((prev) => ({
        ...prev,
        required: {
          ...prev.required,
          SCPMSL_SameLevelParty: "",
        },
      }));
    }
  }
};
  const handleSubmit = async (e) => {
  e.preventDefault();
  
  // Validate form first
  if (!validateForm()) {
    return;
  }
  
  // Prevent duplicate submissions
  if (toast.isActive('save-toast')) {
    return;
  }
  
  // Check if Add button was clicked for selected checkboxes
  if (
    workingSelectedScps.length > 0 &&
    workingSelectedSameLevelParties.length > 0 &&
    !isAddClicked &&
    !isAddClickedSLP
  ) {
    // Case: Neither ADD buttons were clicked for both SCP and SCP Same Level Party
    showToast('error',
      "Please click the ADD button for both SCP Outward Party and SCP Same Level Party."
    );
    return;
  } else if (workingSelectedScps.length > 0 && !isAddClicked) {
    // Case: ADD button for SCP Outward Party was not clicked
    showToast('error', "Please click the ADD button for SCP Outward Party.");
    return;
  } else if (workingSelectedSameLevelParties.length > 0 && !isAddClickedSLP) {
    // Case: ADD button for SCP Same Level Party was not clicked
    showToast('error', "Please click the ADD button for SCP Same Level Party.");
    return;
  }
  
  // Set loading to true at the start of the save operation
  setIsLoading(true);
  
  const payload = {
    SCPM_SCPConfig_ID: formdata.SCPM_SCPConfig_ID,
    SCPM_Status: formdata.SCPM_Status,
    SCPM_ScanningMode: formdata.SCPM_ScanningMode,
    SCPMO_OutwardParty: selectedScps,
    SCPMSL_SameLevelParty: selectedSameLevelParties,
  };

  console.log("Data to be inserted", payload);

  try {
    const response = await axios.put(
      `${config.API_URL}/scp_master/${SCPM_ID}`,
      payload,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    if (response.status === 200) {
      // Log successful update
      logAction(
        `handleSubmit(): SCP : ${formdata.SCPM_Name} updated successfully.`
      );

      // Audit trail - main entry
      const details = {
        AUTR_Message: formdata.SCPM_Name + " Updated",
        AUTR_AuditType: "Update",
      };
      let id = await audittrailpost(details);

      // Audit trail for status change
      if (oldData.SCPM_Status !== formdata.SCPM_Status) {
        const details = {
          AUTRN_ParamererName: "Status",
          AUTRN_ID: id,
          AUTRN_NewValue: formdata.SCPM_Status,
          AUTRN_OldValue: oldData.SCPM_Status,
        };
        audittransection(details);
      }

      // Audit trail for scanning mode change
      if (oldData.SCPM_ScanningMode !== formdata.SCPM_ScanningMode) {
        const details = {
          AUTRN_ParamererName: "SCPM_ScanningMode",
          AUTRN_ID: id,
          AUTRN_NewValue: formdata.SCPM_ScanningMode,
          AUTRN_OldValue: oldData.SCPM_ScanningMode,
        };
        audittransection(details);
      }

      // Audit trail for outward party changes
      const removedOutwardParty = oldData.SCPMO_OutwardParty.filter(
        (id) => !selectedScps.includes(id)
      );
      const addedOutwardParty = selectedScps.filter(
        (id) => !oldData.SCPMO_OutwardParty.includes(id)
      );

      removedOutwardParty.forEach((id1) => {
        const details = {
          AUTRN_ParamererName: "SCP Outward Party",
          AUTRN_ID: id,
          AUTRN_NewValue: "-",
          AUTRN_OldValue: id1,
        };
        audittransection(details);
      });

      addedOutwardParty.forEach((id2) => {
        const details = {
          AUTRN_ParamererName: "SCP Outward Party",
          AUTRN_ID: id,
          AUTRN_NewValue: id2,
          AUTRN_OldValue: "-",
        };
        audittransection(details);
      });

      // Audit trail for same level party changes
      const removedSameLevelParty = oldData.SCPMSL_SameLevelParty.filter(
        (id) => !selectedSameLevelParties.includes(id)
      );
      const addedSameLevelParty = selectedSameLevelParties.filter(
        (id) => !oldData.SCPMSL_SameLevelParty.includes(id)
      );

      removedSameLevelParty.forEach((id3) => {
        const details = {
          AUTRN_ParamererName: "SCP Same Level Party",
          AUTRN_ID: id,
          AUTRN_NewValue: "-",
          AUTRN_OldValue: id3,
        };
        audittransection(details);
      });

      addedSameLevelParty.forEach((id4) => {
        const details = {
          AUTRN_ParamererName: "SCP Same Level Party",
          AUTRN_ID: id,
          AUTRN_NewValue: id4,
          AUTRN_OldValue: "-",
        };
        audittransection(details);
      });

      // Show success toast
      showToast('success', `SCP : ${formdata.SCPM_Name} updated successfully.`, {
        toastId: 'save-toast',
        autoClose: 3000,
        onClose: () => {
          // This callback runs when toast closes
          setIsLoading(false);
          navigate(`/dashboard/scpmaster`);
        },
      });

      // // Backup: Set loading to false after toast auto-close time
      // setTimeout(() => {
      //   setIsLoading(false);
      // }, 3000);

    } else {
      // Handle API error response
      setIsLoading(false);
      console.error(
        "handleSubmit(): Error in updating Data:",
        response.statusText
      );
      showToast('error',
        `SCP : ${formdata.SCPM_Name} could not be updated successfully.`
      );
      logAction("Error came saving data", true);
    }
  } catch (err) {
    // Handle network or server errors
    setIsLoading(false);
    
    if (err.response) {
      // Show exact backend error message
      showToast('error', err.response.data);
    } else {
      console.error("Network error:", err);
      showToast('error',
        `SCP : ${formdata.SCPM_Name} could not be updated successfully.`
      );
      logAction(
        "handleSubmit(): Failed to update data. Please check your network connection.",
        true
      );
    }
  }
};
  const handleCancel = () => {
    logAction("handleCancel():started");

    // Get default scanning mode based on available options
    let defaultScanningMode = "";
    if (scanningModeOptions.length > 0) {
      // Sort options to ensure Vendor comes first
      const sortedOptions = [...scanningModeOptions].sort((a, b) =>
        parseInt(a.value) - parseInt(b.value)
      );

      // Set default based on available options
      if (sortedOptions.length === 1) {
        // If only one option, select it
        defaultScanningMode = sortedOptions[0].value;
      } else if (sortedOptions.length > 1) {
        // If multiple options, leave it blank (empty string)
        defaultScanningMode = "";
      }
    } else {
      // If no options, leave it blank
      defaultScanningMode = "";
    }

    // Reset form data with default scanning mode
    setFormdata({
      SCPM_Name: formdata.SCPM_Name, // Keep name as it's disabled
      SCPM_Caption: formdata.SCPM_Caption, // Keep name as it's disabled
      SCPM_Code: formdata.SCPM_Code, // Keep code as it's disabled
      SCPM_SCPConfig_ID: formdata.SCPM_SCPConfig_ID, // Keep SCP Config as it's disabled
      SCPM_Status: 1, // Keep current status
      SCPM_ScanningMode: defaultScanningMode, // Reset to default (empty if both options exist)
      SCPMO_OutwardParty: "",
      SCPMSL_SameLevelParty: "",
      SCPM_CompanyGrpID: UM_CompanyGrpID,
      SCPM_CompanyID: UM_CompanyID,
    });

    setErrors({
      required: initialData,
      other: initialData,
    });

    // Clear selections but keep the loaded data
    setSelectedScps([]);
    setSelectedSameLevelParties([]);
    setWorkingSelectedScps([]); // Clear working selection
    setWorkingSelectedSameLevelParties([]); // Clear working selection
    setDisabledOutwardScps([]); // Reset disabled outward SCP IDs
    setDisabledSameLevelScps([]); // Reset disabled same level SCP IDs
    setSubmittedSLP(false);
    setSubmitted(false);
    setMessage("");
    setIsAddClicked(false); // Reset the state when resetting the form
    setIsAddClickedSLP(false); // Reset the state when resetting the form

    // Also clear the tables by resetting the selections to empty arrays
    // This ensures the tables won't show any data after reset
    setSelectedScps([]);
    setSelectedSameLevelParties([]);

    logAction("handleCancel():ended form is reset successfully.");
  };
  const handleClearOP = () => {
    setConfirmationMessage(
      "Are you sure you want to clear all SCP Outward Parties ?"
    );
    setOnConfirmAction(() => clearOP);
    setShowConfirmation(true);
  };

  const clearOP = () => {
    // NEW: Re-enable all outward SCP IDs when clearing
    setDisabledOutwardScps([]);
    setSelectedScps([]);
    setWorkingSelectedScps([]); // NEW: Clear working selection
    setSubmitted(false);
    setIsAddClicked(false);
    logAction("clearOP(): Clear all SCP Outward party ");
  };

  const handleClearSLP = () => {
    setConfirmationMessage(
      "Are you sure you want to clear all SCP Same Level Parties ?"
    );
    setOnConfirmAction(() => clearSLP);
    setShowConfirmation(true);
  };
  const clearSLP = () => {
    // NEW: Re-enable all same level SCP IDs when clearing
    setDisabledSameLevelScps([]);
    setSelectedSameLevelParties([]);
    setWorkingSelectedSameLevelParties([]); // NEW: Clear working selection    setSubmittedSLP(false);
    setIsAddClickedSLP(false);
    logAction("clearSLP(): Clear all SCP Same level party ");
  };

  const handleDeleteSCP = (scpId) => {
    const scpName = scps.find((scp) => scp.SCPM_ID === scpId)?.SCPM_Name || "";
    setConfirmationMessage(
      `Are you sure you want to remove this SCP Same Level Party : ${scpName} ?`
    );
    // setConfirmationMessage('Are you sure you want to delete this SCP Same level party?');
    setOnConfirmAction(() => () => deleteSCP(scpId));
    setShowConfirmation(true);
  };

  const deleteSCP = (scpId) => {
    const updatedSameLevelParties = selectedSameLevelParties.filter(
      (scp) => scp !== scpId
    );
    setSelectedSameLevelParties(updatedSameLevelParties);


    // NEW: Re-enable the deleted SCP ID for same level party
    setDisabledSameLevelScps(disabledSameLevelScps.filter(id => id !== scpId));

    // NEW: Also uncheck it in the working selection
    setWorkingSelectedSameLevelParties(
      workingSelectedSameLevelParties.filter(id => id !== scpId)
    );
    logAction("deleteSCP(): SCP Same level delete by id ");

    if (selectedSameLevelParties.length === 1) {
      setSubmittedSLP(false);
    }
  };

  const handleDeleteOP = (scpId) => {
    const scpName =
      op_scps.find((scp) => scp.SCPM_ID === scpId)?.SCPM_Name || "";
    setConfirmationMessage(
      `Are you sure you want to remove SCP Outward Party : ${scpName} ?`
    );
    setOnConfirmAction(() => () => deleteOP(scpId));
    setShowConfirmation(true);
  };

  const deleteOP = (scpId) => {
    const updatedScps = selectedScps.filter((scp) => scp !== scpId);
    setSelectedScps(updatedScps);

    // NEW: Re-enable the deleted SCP ID for outward party
    setDisabledOutwardScps(disabledOutwardScps.filter(id => id !== scpId));

    // NEW: Also uncheck it in the working selection
    setWorkingSelectedScps(
      workingSelectedScps.filter(id => id !== scpId)
    );
    logAction("deleteOP(): SCP Outward party delete by id ");

    if (selectedScps.length === 1) {
      setSubmitted(false);
    }
  };
  const handleConfirm = () => {
    if (onConfirmAction) {
      onConfirmAction();
    }
    setShowConfirmation(false);
    setConfirmationMessage("");
    setOnConfirmAction(null);
  };

  const handleCancelConfirm = () => {
    setShowConfirmation(false);
    setConfirmationMessage("");
    setOnConfirmAction(null);
  };
  const logAction = async (action, isError = false) => {
    console.log(`${isError ? "[ERROR] " : ""}${action}`);
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "SCP-Master:",
          action,
          userCode: UM_UserCode,
          isError,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to log action");
      }
    } catch (error) {
      console.error("Error logging action:", error);
    }
  };
  return (
    <React.Fragment>

      <ToastContainer
        style={{
          marginTop: "73px",
          fontSize: "14px",
          width: "40%",
        }}
      />
      {isLoading && (
        <div style={{
          position: 'fixed', // Sit on top of the page content
          left: 0,
          top: 0,
          width: '100%', // Full width
          height: '100%', // Full height

          zIndex: 1000 // Sit on top of the other elements
        }} />
      )}
      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="main_container">
          <h3 className=" formHeading">SCP Master </h3>

          {/* <Link to={`/dashboard/${UM_GroupId}/${UM_CompanyID}/${UM_CompanyGrpID}/${UM_UserId}/${UM_UserCode}/${selectedScpId}/scpmlist`} className="m-4 link_btn" type="button">Back</Link> */}

          <div className="row">
            {/* <div className="form-section"> */}
              <div className="col-md-6">
                <label>
                  SCP Name{" "}
                  <span className="text-danger  ">
                    {errors.required.SCPM_Name}
                  </span>
                </label>
                <input
                  type="tel"
                  name="SCPM_Name"
                  className="form-input"
                  value={formdata.SCPM_Name}
                  onChange={handleInput}
                  disabled
                />
                <div className="text-danger  ">
                  {errors.other.SCPM_Name}
                </div>
              </div>

              <div className="col-md-6">
                <label>
                  SCP Caption Name{" "}
                  <span className="text-danger  ">
                    {errors.required.SCPM_Caption}
                  </span>
                </label>
                <input
                  type="tel"
                  name="SCPM_Caption"
                  className="form-input"
                  value={formdata.SCPM_Caption}
                  onChange={handleInput}
                  disabled
                />
                <div className="text-danger  ">
                  {errors.other.SCPM_Caption}
                </div>
              </div>
              <div className="col-md-6">
                <label>
                  SCP Code{" "}
                  <span className="text-danger  ">
                    {errors.required.SCPM_Code}
                  </span>
                </label>
                <input
                  type="tel"
                  name="SCPM_Code"
                  className="form-input"
                  value={formdata.SCPM_Code}
                  onChange={handleInput}
                  disabled
                />
                <div className="text-danger  ">
                  {errors.other.SCPM_Code}
                </div>
              </div>
              <div className="col-md-6">
                <label>
                  SCP Level Name{" "}
                  <span className="text-danger  ">
                    {errors.required.SCPM_SCPConfig_ID}
                  </span>
                </label>
                <div className="select-container">
                  <Select
                    name="SCPM_SCPConfig_ID"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={scpLevelNames.map((scpLevel) => ({
                      value: scpLevel.SCP_ID,
                      label: scpLevel.SCP_LevelName
                    }))}
                    value={scpLevelNames
                      .filter(scpLevel => scpLevel.SCP_ID === formdata.SCPM_SCPConfig_ID)
                      .map(scpLevel => ({
                        value: scpLevel.SCP_ID,
                        label: scpLevel.SCP_LevelName
                      }))}
                    onChange={(selectedOption) => {
                      handleInput({
                        target: {
                          name: "SCPM_SCPConfig_ID",
                          value: selectedOption ? selectedOption.value : ""
                        }
                      });
                    }}
                    placeholder="--Select--"
                    isDisabled={true} // Keep disabled as per your original code
                    isSearchable={true}
                    noOptionsMessage={() => "No options available"}
                    onMenuOpen={() => handleSelectOpen("SCPM_SCPConfig_ID")}
                    onMenuClose={handleSelectClose}
                  />
                  <div className="icon-container_list myList">
                    {isSelectOpen === "SCPM_SCPConfig_ID" ? (
                      <IoCaretUpOutline />
                    ) : (
                      <IoCaretDownOutline />
                    )}
                  </div>
                  <div className="text-danger  ">
                    {errors.other.SCPM_SCPConfig_ID}
                  </div>
                </div>
              </div>
                           <div className="col-md-6">
                <label>
                  Scanning mode{" "}
                  <span className="text-danger  ">
                    {errors.required.SCPM_ScanningMode}
                  </span>
                </label>
                <div className="select-container">
                  <Select
                    name="SCPM_ScanningMode"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={scanningModeOptions.length > 0 ? scanningModeOptions : defaultScanningModeOptions}
                    value={
                      formdata.SCPM_ScanningMode
                        ? (scanningModeOptions.length > 0 ? scanningModeOptions : defaultScanningModeOptions)
                          .find(option => option.value === formdata.SCPM_ScanningMode)
                        : null  // IMPORTANT: Set to null when empty
                    }
                    onChange={(selectedOption) => {
                      handleInput({
                        target: {
                          name: "SCPM_ScanningMode",
                          value: selectedOption ? selectedOption.value : ""
                        }
                      });
                    }}
                    placeholder="--Select--"
                    isSearchable={true}
                    isLoading={scanningModeLoading}
                    onMenuOpen={() => handleSelectOpen("SCPM_ScanningMode")}
                    onMenuClose={handleSelectClose}
                  />
                  <div className="icon-container_list myList">
                    {isSelectOpen === "SCPM_ScanningMode" ? (
                      <IoCaretUpOutline />
                    ) : (
                      <IoCaretDownOutline />
                    )}
                  </div>
                </div>
                <div className="text-danger  ">
                  {errors.other.SCPM_ScanningMode}
                </div>
              </div>
              <div className="col-md-6">
                <label>
                  Status{" "}
                  <span className="text-danger  ">
                    {errors.required.SCPM_Status}
                  </span>
                </label>
                <div className="select-container">
                  <Select
                    name="SCPM_Status"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={[
                      { value: 1, label: "Active" },
                      { value: 2, label: "Inactive" }
                    ]}
                    value={formdata.SCPM_Status ? {
                      value: formdata.SCPM_Status,
                      label: formdata.SCPM_Status === 1 ? "Active" : "Inactive"
                    } : { value: 1, label: "Active" }}
                    onChange={(selectedOption) => {
                      handleInput({
                        target: {
                          name: "SCPM_Status",
                          value: selectedOption ? selectedOption.value : 1
                        }
                      });
                    }}
                    placeholder="--Select--"
                    isSearchable={false}
                    onMenuOpen={() => handleSelectOpen("SCPM_Status")}
                    onMenuClose={handleSelectClose}
                  />
                  <div className="icon-container_list myList">
                    {isSelectOpen === "SCPM_Status" ? (
                      <IoCaretUpOutline />
                    ) : (
                      <IoCaretDownOutline />
                    )}
                  </div>
                </div>
                <div className="text-danger  ">
                  {errors.other.SCPM_Status}
                </div>
              </div>
            {/* </div> */}
            <div className="col-md-12 mt-2">
              <div className="row">
                {scpAllowMutlipleParty.SCP_AllowMutliplePartyOutward !== 0 && (
                  <div className="col-md-6">
                    <label>
                      SCP Outward Party{" "}
                      <span className="text-danger  ">
                        {errors.required.SCPMO_OutwardParty}
                      </span>
                    </label>
                    <div className="form-checked">
                      <div>
                        <input
                          type="checkbox"
                          className="form-check-input ms-0"
                          onChange={(e) =>
                            handleSelectAll(
                              "SCPMO_OutwardParty",
                              e.target.checked
                            )
                          }
                          // checked={selectedScps.length > 0 && selectedScps.length === op_scps.length}
                          checked={workingSelectedScps.length > 0 && workingSelectedScps.length === op_scps.length}
                          // disabled={op_scps.length === 0}
                          disabled={op_scps.length === 0 || op_scps.every(scp => disabledOutwardScps.includes(scp.SCPM_ID))} // NEW: Disable if all options are disabled
                        />
                        <label
                          className="form-check-label"
                          htmlFor="selectAllOutward"
                        >
                          Select All
                        </label>
                      </div>
                      {op_scps.map((scp) => (
                        <div key={scp.SCPM_ID}>
                          <input
                            className="form-check-input ms-0"
                            type="checkbox"
                            name="SCPMO_OutwardParty"
                            onChange={handleCheckboxChange}
                            // checked={selectedScps.includes(scp.SCPM_ID)}
                            // value={scp.SCPM_ID}
                            checked={workingSelectedScps.includes(scp.SCPM_ID)} // Use working selection
                            value={scp.SCPM_ID}
                            disabled={disabledOutwardScps.includes(scp.SCPM_ID)} // NEW: Disable if already added
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`flexCheckDefault${scp.SCPM_ID}`}
                          >
                            {scp.SCPM_Name}
                            {disabledOutwardScps.includes(scp.SCPM_ID)} {/* NEW: Show added status */}
                          </label>
                        </div>
                      ))}
                    </div>

                    <div className="text-danger  ">
                      {errors.other.SCPMO_OutwardParty}
                    </div>
                    <button
                      className="scp_party_add_btn"
                      type="submit"
                      onClick={handleOPSubmit}
                    // disabled={submitted}
                    >
                      ADD
                    </button>
                  </div>
                )}

                {/* // Add a new input field for SCPMSL_SameLevelParty */}
                {scpAllowMutlipleParty.SCP_AllowMutliplePartySameLevelOutward !==
                  0 && (
                    <div className="col-md-6">
                      <label>
                        SCP Same Level Party{" "}
                        <span className="text-danger  ">
                          {errors.required.SCPMSL_SameLevelParty}
                        </span>
                      </label>
                      <div className="form-checked">
                        <div>
                          <input
                            type="checkbox"
                            className="form-check-input ms-0"
                            onChange={(e) =>
                              handleSelectAll(
                                "SCPMSL_SameLevelParty",
                                e.target.checked
                              )
                            }
                            // checked={
                            //   selectedSameLevelParties.length ===
                            //   scps.filter(scp => scp.SCPM_Name !== formdata.SCPM_Name).length
                            // }
                            checked={
                              workingSelectedSameLevelParties.length > 0 &&
                              workingSelectedSameLevelParties.length ===
                              scps.filter(scp => scp.SCPM_Name !== formdata.SCPM_Name).length
                            }
                            // disabled={scps.filter(scp => scp.SCPM_Name !== formdata.SCPM_Name).length === 0}
                            disabled={
                              scps.filter(scp => scp.SCPM_Name !== formdata.SCPM_Name).length === 0 ||
                              scps.filter(scp => scp.SCPM_Name !== formdata.SCPM_Name).every(scp => disabledSameLevelScps.includes(scp.SCPM_ID))
                            } // NEW: Disable if all options are disabled
                          />
                          <label
                            className="form-check-label"
                            htmlFor="selectAllSLP"
                          >
                            Select All
                          </label>
                        </div>
                        {scps.map(
                          (scp) =>
                            scp.SCPM_Name !== formdata.SCPM_Name && (
                              <div key={scp.SCPM_ID}>
                                <input
                                  className="form-check-input ms-0"
                                  type="checkbox"
                                  name="SCPMSL_SameLevelParty"
                                  onChange={handleCheckboxChange}
                                  // checked={selectedSameLevelParties.includes(
                                  //   scp.SCPM_ID
                                  // )}
                                  checked={workingSelectedSameLevelParties.includes(scp.SCPM_ID)} // Use working selection
                                  value={scp.SCPM_ID}
                                  disabled={disabledSameLevelScps.includes(scp.SCPM_ID)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`flexCheckDefaultSameLevel${scp.SCPM_ID}`}
                                >
                                  {scp.SCPM_Name}
                                  {disabledSameLevelScps.includes(scp.SCPM_ID)} {/* NEW: Show added status */}

                                </label>
                              </div>
                            )
                        )}
                      </div>
                      <div className="text-danger  ">
                        {errors.other.SCPMSL_SameLevelParty}
                      </div>
                      <button
                        className="scp_party_add_btn"
                        type="submit"
                        onClick={handleSLPSubmit}
                      // disabled={submittedSLP}
                      >
                        ADD
                      </button>
                    </div>
                  )}

                <div className="col-md-6 mt-3 ">
                  {submitted && selectedScps.length > 0 && (
                    <>
                      <div className="table_div">
                        <table className="tableClass_scp">
                          <thead>
                            <tr>
                              <th style={{width: '70px'}}>Sr. No.</th>
                              <th> SCP Upper and Lower Level Name</th>
                              <th style={{width: '70px'}}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectedScps.map((scp, index) => (
                              <tr key={index + 1}>
                                <td>{index + 1}</td>
                                <td>
                                  {
                                    op_scps.find((item) => item.SCPM_ID === scp)
                                      ?.SCPM_Name
                                  }
                                </td>
                                <td>
                                  <img
                                    src={Icon5}
                                    title="Remove"
                                    alt="trash"
                                    className="delete_btn"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleDeleteOP(scp)}
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div>
                        {submitted && selectedScps.length > 1 && (
                          <button
                            className="m-2 scp_party_clearall_btn"
                            type="button"
                            onClick={handleClearOP}
                            disabled={!(submitted && selectedScps.length > 1)}
                            style={{
                              opacity: submitted && selectedScps.length > 1 ? 1 : 0.5,
                              cursor: submitted && selectedScps.length > 1 ? "pointer" : "not-allowed",
                            }}
                          >
                            CLEAR ALL
                          </button>
                        )}

                      </div>
                    </>
                  )}
                </div>
                {/* SCP Same Level Party table */}
                <div className="col-md-6 mt-3">
                  {/* {submittedSLP && selectedSameLevelParties.length > 0 && ( */}
                  {submittedSLP && selectedSameLevelParties.filter(scpId => {
                    const scp = scps.find(item => item.SCPM_ID === scpId);
                    return scp && scp.SCPM_Name !== formdata.SCPM_Name;
                  }).length > 0 && (
                      <>
                        <div className="table_div">
                          <table className="tableClass_scp">
                            <thead>
                              <tr>
                                <th style={{width: '70px'}}>Sr. No.</th>
                                <th> SCP Same Level Party</th>
                                <th style={{width: '70px'}}>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {selectedSameLevelParties
                                .filter(scpId => {
                                  const scp = scps.find(item => item.SCPM_ID === scpId);
                                  return scp && scp.SCPM_Name !== formdata.SCPM_Name;
                                })
                                .map((scp, index) => (
                                  <tr key={index + 1}>
                                    <td>{index + 1}</td>
                                    <td>
                                      {scps.find(item => item.SCPM_ID === scp)?.SCPM_Name}
                                    </td>
                                    <td>
                                      <img
                                        src={Icon5}
                                        alt="trash"
                                        title="Remove"
                                        className="delete_btn"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleDeleteSCP(scp)}
                                      />
                                    </td>
                                  </tr>
                                ))
                              }
                            </tbody>
                          </table>
                        </div>
                        {submittedSLP && selectedSameLevelParties.length > 1 && (
                          <button
                            className="m-2 scp_party_clearall_btn"
                            type="button"
                            onClick={handleClearSLP}
                            disabled={!(submittedSLP && selectedSameLevelParties.length > 1)}
                            style={{
                              opacity: submittedSLP && selectedSameLevelParties.length > 1 ? 1 : 0.5,
                              cursor: submittedSLP && selectedSameLevelParties.length > 1 ? "pointer" : "not-allowed",
                            }}
                          >
                            CLEAR ALL
                          </button>
                        )}
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button-container">
          <button className="save_btn " type="submit">
            SAVE
          </button>
          <button className="reset_btn" type="button" onClick={handleCancel}>
            RESET
          </button>
          <Link to={`/dashboard/scpmlist`} className="list_btn" type="button">
            LIST
          </Link>
        </div>
        {/* Confirmation Popup */}
        {showConfirmation && (
          <div className="popup_overlay">
            <div className="resetpopup">
              <h1>:: User Confirmation ::</h1>
              <h4>{confirmationMessage}</h4>
              <div className="popup_btn_container">
                <button className="yes_btn " onClick={handleConfirm}>
                  Yes
                </button>
                <button className="no_btn " onClick={handleCancelConfirm}>
                  No
                </button>
              </div>
            </div>
          </div>
        )}
      </form>
    </React.Fragment>
  );
}
export default SCPMEdit;
